import { Role, rolePermissionsMap } from '@/constants/rolePermissions';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

const ALLOWED_ROLES: Role[] = Object.keys(rolePermissionsMap) as Role[];

const ProtectedRoute = () => {
  const { user, profile } = useAuth();

  if (
    !user ||
    !profile ||
    profile.status !== 'active' ||
    !ALLOWED_ROLES.includes(profile.role)
  ) {
    return <Navigate to={'/login'} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
